import { render, staticRenderFns } from "./Reject080List.vue?vue&type=template&id=2ed52b3a&scoped=true&"
import script from "./Reject080List.vue?vue&type=script&lang=ts&"
export * from "./Reject080List.vue?vue&type=script&lang=ts&"
import style0 from "./Reject080List.vue?vue&type=style&index=0&id=2ed52b3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed52b3a",
  null
  
)

export default component.exports